document.addEventListener('click', function (event) {
  const headerMenu = document.querySelector('header-menu');
  const menuItems = document.querySelectorAll(
    '.header-menu .menu-list__list-item'
  );

  let clickedInsideSpecialMenu = false;

  menuItems.forEach((item) => {
    const link = item.querySelector(':scope > a');
    if (!link) return;

    const title = link.textContent.trim();

    if (title !== 'Kedi' && title !== 'Köpek') return;

    if (item.contains(event.target)) {
      clickedInsideSpecialMenu = true;
    }
  });

  if (clickedInsideSpecialMenu) return;

  menuItems.forEach((item) => {
    const link = item.querySelector(':scope > a');
    if (!link) return;

    const title = link.textContent.trim();

    if (title !== 'Kedi' && title !== 'Köpek') return;

    link.setAttribute('aria-expanded', 'false');
    link.removeAttribute('data-safety-box');
  });

  const header = document.querySelector('#header-component');

  if (header) {
    header.style.removeProperty('--submenu-height');
    header.style.removeProperty('--full-open-header-height');
  }

  document.documentElement.style.removeProperty('--submenu-height');
  document.documentElement.style.removeProperty('--full-open-header-height');

  window.dispatchEvent(new Event('resize'));
});document.addEventListener('DOMContentLoaded', function () {
  const kedi = document.querySelector('.menu-list__list-item > a[href*="/collections/kedi"]');
  const kopek = document.querySelector('.menu-list__list-item > a[href*="/collections/kopek"]');

  function kontrolEt() {
    if (window.scrollY > 50) {
      if (kedi) kedi.style.display = 'none';
      if (kopek) kopek.style.display = 'none';
    } else {
      if (kedi) kedi.style.display = '';
      if (kopek) kopek.style.display = '';
    }
  }

  window.addEventListener('scroll', kontrolEt);
  kontrolEt();
});